// extracted by mini-css-extract-plugin
module.exports = {"root":"Image_root__EEV0M","caption":"Image_caption__MOxci"};